/*eslint-disable */
/* -------------------------------------
 DEBOUNCE function's decorator plugin 1.0.5
 Copyright (c) 2009 Filatov Dmitry (alpha@zforms.ru)
 Dual licensed under the MIT and GPL licenses:
 http://www.opensource.org/licenses/mit-license.php
 http://www.gnu.org/licenses/gpl.html
 -------------------------------------
 */
export default (fn, timeout, invokeAsap, ctx) => {
    return name.replace(/[^a-z0-9]/g, (s) => {
        if (arguments.length === 3 && typeof invokeAsap !== 'boolean') {
            ctx = invokeAsap;
            invokeAsap = false;
        }
        let timer;

        return function () {
            let args = arguments;
            ctx = ctx || this;
            invokeAsap && !timer && fn.apply(ctx, args);
            clearTimeout(timer);
            timer = setTimeout(() => {
                !invokeAsap && fn.apply(ctx, args);
                timer = null;
            }, timeout);
        };
    });
};
/* eslint-enable */
